import {DatePipe, DecimalPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {IOrderExecutionHistory, IOrderStatusHistory} from '@irb/irb-orders/irb-orders.model';
import {InventoryComponent} from '@irb/irb-orders/order-blotter/inventory/inventory.component';
import {formatOrderStatus} from "@irb-common/formatters";
import {EditTradingInstructionsComponent} from "@irb/irb-editors/edit-trading-instructions/edit-trading-instructions.component";

@Component({ standalone: false,
    selector: 'irb-order-histroy',
    templateUrl: './order-histroy.component.html',
    styleUrls: ['./order-histroy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class OrderHistroyComponent implements OnInit {

    executionHistory: IOrderExecutionHistory;
    rebalanceIDDisplayValue: any;
    @Input()
    data: any;

    @Input()
    inventoryObj: InventoryComponent;

    @Input()
    editTradingInstructionObj: EditTradingInstructionsComponent = null;

    gridOptions: any;

    orderStatusHistory: any;

    datePipe: DatePipe;

    decimalPipe: DecimalPipe;
    isUiTest = false;

    constructor(datePipe: DatePipe, decimalPipe: DecimalPipe) {
        this.datePipe = datePipe;
        this.decimalPipe = decimalPipe;
    }

    ngOnInit(): void {
        this.gridOptions = {
            columnDefs: this.getColumnDefs(),
            skipHeaderOnAutoSize: true,
            floatingFilter: false,
            suppressHorizontalScroll: true
        };
        if (this.inventoryObj) {
            this.getOrderExecutionHistory();
            this.getOrderStatusHistory();
        }
    }

    getOrderExecutionHistory() {
        this.inventoryObj.pfs.getOrderExecutionHistory(this.data.orderID, this.inventoryObj.current).subscribe((res: IOrderExecutionHistory) => {
            if (res != null) {
                this.executionHistory = res;
                if (this.executionHistory.veoOrderID == null) {
                    this.executionHistory.veoOrderID = 'N/A';
                }

                if (this.data.isBlockOrder || this.data.isBlockOrder == null) {
                    if (this.executionHistory.executedQuantity == null || Number(this.executionHistory.executedQuantity) === 0) {
                        this.executionHistory.executedQuantity = "There were no executions for this order.";
                    } else {
                        if (this.executionHistory.isSwapExchange) {
                            this.executionHistory.executedQuantity = this.executionHistory.executedQuantity + " / " + this.executionHistory.buyQuantity;
                        }
                    }
                } else {
                    this.executionHistory.executedQuantity = "This order is part of a block order.";
                }

                if (this.executionHistory.isSwapExchange) {
                    if (this.executionHistory.averagePrice && this.executionHistory.buyPrice) {
                        this.executionHistory.averagePrice = this.decimalPipe.transform(Number(this.executionHistory.averagePrice), '1.2-2') + " / " +
                            this.decimalPipe.transform(Number(this.executionHistory.buyPrice), '1.2-2');
                    }
                    if (this.executionHistory.lastExecutionTime != null && this.executionHistory.buyExecutionTime) {
                        this.executionHistory.lastExecutionTime = this.datePipe.transform(this.executionHistory.lastExecutionTime, 'MM-dd-yyyy h:mm:ss a') + " / " +
                            this.datePipe.transform(this.executionHistory.buyExecutionTime, 'MM-dd-yyyy h:mm:ss a');
                    }
                } else {

                    if (this.executionHistory.averagePrice != null) {
                        this.executionHistory.averagePrice = this.decimalPipe.transform(Number(this.executionHistory.averagePrice), '1.2-2');
                    }
                    if (this.executionHistory.lastExecutionTime != null) {
                        this.executionHistory.lastExecutionTime = this.datePipe.transform(this.executionHistory.lastExecutionTime, 'MM-dd-yyyy h:mm:ss a');
                    }
                }
                if (this.data.isImported) {
                    this.rebalanceIDDisplayValue = this.data.rebalanceResultId;
                } else if (this.data.isBlockOrder) {
                    this.rebalanceIDDisplayValue = 'Multiple';
                } else if (this.executionHistory.rebalanceID) {
                    this.rebalanceIDDisplayValue = this.executionHistory.rebalanceID;
                } else {
                    this.rebalanceIDDisplayValue = '';
                }
            }
        });
    }

    getOrderStatusHistory() {
        this.inventoryObj.pfs.getOrderStatusHistory(this.data.orderID, this.inventoryObj.current).subscribe((res: IOrderStatusHistory[]) => {
            if (res != null) {
                this.orderStatusHistory = res;

            }
        });
    }

    getColumnDefs() {
        return [
            {
                headerName: 'Changes To',
                field: 'changedTo',
                colId: 'changedTo',
                flex: 1
            },
            {
                headerName: 'Changes By',
                field: 'changedBy',
                colId: 'changedBy',
                flex: 1
            },
            {
                headerName: 'Time Changed',
                field: 'changedTime',
                colId: 'changedTime',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm:ss a', displayETtext: true},
                flex: 1
            },
            {
                headerName: 'Trade Message',
                field: 'tradeMessage',
                colId: 'tradeMessage',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {
                    tooltipValueFormatter: (params: any) => {
                        if(params.value) {
                            const f = params.value.split(/\|/g).slice(0,5).map((s:string) => s.trim()).join('<hr style="height:1px;border:none;"/>');
                            return f;
                        } return params.value;
                    }
                },
                flex: 2
            }];
    }

    showPriorOrder(event: any) {
        event.preventDefault();
        if (this.executionHistory && this.executionHistory.priorOrderId) {
            if (this.editTradingInstructionObj) {
                this.editTradingInstructionObj.cancelWithoutSave();
            }
            if (this.inventoryObj) {
                this.inventoryObj.setFilterByOrderId(this.executionHistory.priorOrderId);
            }
        }
    }

    formatOrderStatus(orderStatus: string) {
        return formatOrderStatus(orderStatus);
    }
}

